import { styled } from '@abyss/web/tools/styled';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';

export const StyledFontSizeModal = styled(V2ModalDialog, {
  '.abyss-modal-base-header-container': {
    padding: '16px 16px 16px 16px !important',
    height: 'auto !important',
    width: '100% !important',
    maxWidth: '500px',
    borderRadius: '8px',
  },
  '.abyss-modal-base-header': {
    padding: '0 !important',
    fontSize: '28px !important',
    fontWeight: '700 !important',
    height: 'auto !important',
    width: '100% !important',
  },

  '.abyss-text-root': {
    color: 'var(--web-semantic-color-text-content-tertiary, #4B4D4F)',
    fontSize: '16px',
    fontFamily: 'UHC2020 Sans',
    fontStyle: 'regular',
    fontWeight: '400',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  '.abyss-button-root': {
    padding: '8px 24px',
  },
});
